import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black border-t border-zinc-900 py-12">
      <div className="max-w-7xl mx-auto px-6 flex flex-col items-center">
        
        {/* LOGO PEQUEÑO */}
        <div className="h-12 w-12 rounded-full border border-yellow-400/30 overflow-hidden mb-6 opacity-60">
          <img src="/logo-pabs.png" alt="PABS" className="h-full w-full object-contain p-1" />
        </div>

        {/* TEXTO PRINCIPAL */}
        <p className="text-zinc-500 text-xs font-bold tracking-[0.2em] uppercase text-center mb-4">
          PABS Programa de Apoyo de Beneficio Social
        </p>

        {/* FIRMA DE TU AGENCIA */}
        <div className="flex flex-col items-center gap-1">
          <p className="text-zinc-600 text-[10px] uppercase tracking-widest">
            © {currentYear} Todos los derechos reservados
          </p>
          <p className="text-zinc-400 text-[10px] uppercase tracking-[0.3em] font-black mt-2">
            Hecho por <span className="text-yellow-400/80">Tecolotl Tech</span>
          </p>
        </div>

      </div>
    </footer>
  );
};

export default Footer;